import { ReactElement } from "react";

import { Factor } from "types/factor/factor";

import { MFA_FACTOR_COPY } from "../../../constants/factorCopy";

import getPhoneNumber from "../../../util/getPhoneNumber";

import styles from "./header-description.module.css";

const HeaderDescription = ({ factor }: { factor: Factor }): ReactElement => {
  const copy = MFA_FACTOR_COPY[factor.key];
  let description = factor.flags.isActive
    ? copy.activeDescription
    : copy.inactiveDescription;

  if (typeof description === "function") {
    description = description(getPhoneNumber(factor));
  }

  return <div className={styles.headerDescription}>{description}</div>;
};

export default HeaderDescription;
